import { useForm } from '@mantine/form';
import { useState } from 'react';
import {
	validateEmail,
	validatePassword,
	validateText,
	validateUsername,
} from '../../../util/validation/commonValidation';
import type { UpsertStockAccountDto } from '../types/StockAccountDto';

const defaultUpsertStockAccount: UpsertStockAccountDto = {
	id: '',
	username: '',
	email: '',
	firstName: '',
	lastName: '',
	password: '',
	checkPassword: '',
	branchId: '',
	organisationId: '',
	isEdit: false,
};

export function useUpsertStockAccountForm(
	upsertAccount: UpsertStockAccountDto = defaultUpsertStockAccount,
) {
	const [inputs, setInputs] = useState<UpsertStockAccountDto>(upsertAccount);

	const form = useForm<UpsertStockAccountDto>({
		mode: 'uncontrolled',
		initialValues: inputs,
		validate: {
			username: (value) => validateUsername(value),
			email: (value) => validateEmail(value, false),
			firstName: (value) => validateText(value, false, 'First name', 40),
			lastName: (value) => validateText(value, false, 'Last name', 40),
			password: (value, values) => validatePassword(value, values.isEdit),
			checkPassword: (value, values) => {
				// biome-ignore lint/suspicious/noDoubleEquals: <explanation>
				if (!values.isEdit && value != values.password) {
					return 'Passwords do not match';
				}
			},
			organisationId: (value) => {
				if (value === '') {
					return 'Please select an organisation';
				}
			},
			branchId: (value) => {
				if (value === '') {
					return 'Please select a branch';
				}
			},
		},
		onValuesChange: (v) => {
			setInputs(v);
		},
	});

	return { form, inputs };
}
